import styles from './vault-info-card.module.scss';

type VaultInfoCardProps = {
  title: string;
  description: string;
  icon: any;
  isIconRightAligned: boolean;
};

const VaultInfoCard: React.FC<VaultInfoCardProps> = ({
  title,
  description,
  icon,
  isIconRightAligned,
}) => (
  <div className={styles.content}>
    {!isIconRightAligned ? (
      <div className={styles.iconContainer}>{icon}</div>
    ) : null}
    <div className={styles.contentText}>
      <h2 className="text__heading4__gray800">{title}</h2>
      <span className="text__body__regular__large__gray700">{description}</span>
    </div>
    {isIconRightAligned ? (
      <div className={styles.iconContainer}>{icon}</div>
    ) : null}
  </div>
);

export { VaultInfoCard };
